<template>
	<span class="input-select">
		<multiselect
			:value="selected"
			@input="$emit('input', $event)"
			:options="options"
			:searchable="searchable"
			:allow-empty="empty"
			:preselect-first="preselectFirst"
			:taggable="taggable"
			label="name"
			tag-placeholder=""
			:show-labels="false"
			track-by="value"
			:multiple="multiple"
			:close-on-select="closeOnSelect"
			:hide-selected="hideSelected"
			:show-no-options="true"
			:placeholder="placeholder"
			:disabled="disabled"
			:name="name"
			:id="id"
			ref="ref"
		>
			<span
				slot="caret"
				class="caret"
				slot-scope="{ toggle }"
				@mousedown.prevent.stop="toggle"
			>
				<svg-chevron-down />
			</span>
			<template slot="tag" slot-scope="{ option, remove }">
				<span class="multiselect__tag">
					<span>{{ option.name }}</span>
					<span class="remove-tag" @click="remove(option)">
						<svg-times
							class="remove-tag"
						/>
					</span>
				</span>
			</template>

			<div
				slot="clear"
				class="multiselect__clear"
				v-if="clearable"
				slot-scope="{ search }"
			>
				<span class="clear-results" @mousedown.prevent.stop="$emit('clear', $event, search)">
					<svg-times class="clear-results-icon"/>
				</span>
			</div>

			<template
				slot="noOptions"
			>
				No more options available.
			</template>
		</multiselect>
	</span>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css'
export default {
	props : {
		options : {
			type     : Array,
			required : true
		},
		selected    : [ Object, String, Array ],
		placeholder : String,
		taggable    : {
			type : Boolean,
			default () {
				return false
			}
		},
		multiple : {
			type : Boolean,
			default () {
				return false
			}
		},
		empty : {
			type : Boolean,
			default () {
				return true
			}
		},
		disabled : {
			type : Boolean,
			default () {
				return false
			}
		},
		closeOnSelect : {
			type : Boolean,
			default () {
				return ! this.multiple
			}
		},
		preselectFirst : {
			type : Boolean,
			default () {
				return true
			}
		},
		hideSelected : {
			type : Boolean,
			default () {
				return false
			}
		},
		searchable : {
			type : Boolean,
			default () {
				return false
			}
		},
		clearable : {
			type : Boolean,
			default () {
				return false
			}
		},
		name : {
			type : String
		},
		id : {
			type : String
		}
	}
}
</script>

<style lang="scss">
.input-select {
	display: inline-block;
	position: relative;

	.caret, .clear-results {
		position: absolute;
		top: 14px;
		right: 14px;
		z-index: 50;
		color: #9DB3DC;

		svg {
			vertical-align: top;
			width: 10px;
			height: auto;
			transition: 0.2s;
			cursor: pointer;
		}
	}
	.caret + .multiselect__clear .clear-results {
		top: 13px;
		right: 38px;
		.clear-results-icon {
			width: 8px;
			height: auto;
		}
	}
}
</style>